import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table } from "antd";
import svg27 from "../../../../../../assets/svg/svg27.svg";
import svg29 from "../../../../../../assets/svg/svg29.svg";
import svg12 from "../../../../../../assets/svg/svg12.svg";
import svg13 from "../../../../../../assets/svg/svg13.svg";
import { Link, useNavigate } from "react-router-dom";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import { fetchData } from "../../../../../../features/fetch/fetchSlice";
import moment from "moment";
import ActivityAdd from "./modal/ActivityAdd";
import CardLoading from "../../../../../../components/CardLoading";
import Search from "../../../../../../components/Search";
import toast from "react-hot-toast";
import ConfirmModal from "../../../../../../components/ConfirmModal";
import { save } from "../../../../../../features/save/saveSlice";

function ActivityTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const url = "api/v2/mainProject/activities/get";
  const { loading, data, count, activeObjOngoingProject } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      periods: state.fetch.periods,
      activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
    })
  );

  const { refetchKey } = useSelector((state) => state.global);
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState();
  const [prodd2, setProdd2] = useState();
  const { open, handleCancel, handleOpen } = useModalToggle();
  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        usrFirstname: e.target.value == "" ? null : e.target.value,
        paMainProject: activeObjOngoingProject?.projectId,
        start: 0,
        limit: null,
      })
    );
    setPageIndex(0);
  };

  const handleEdit = async () => {
    await handleOpen();
  };
  const handleAdd = async (item) => { 
    await setProdd();
    await setProdd2(item);
    await handleOpen();
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/mainProject/activities/delete",
        paId: prodd?.paId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg13} alt="svg13" className="w-4 h-4" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
        </div>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        limit: 1000,
        start: 0,
        paMainProject: activeObjOngoingProject?.projectId,
      })
    );
  }
  useEffect(() => {
    if (refetchKey == 4) {
      fetchTableData();
    }
  }, [refetchKey]);

  useEffect(() => {
    fetchTableData();
  }, []);

  const columns = [
    {
      title: "Activity",
      dataIndex: "paComponetName",
      render: (_, record, index) => {
        if (record.isGroup) {
          return {
            children: (
              <div className="flex items-center  gap-x-[1.25rem] font-interSans font-[600] text-[1rem] text-[#23262F]">
                <div className="bg-[#D6E1F5] w-[2.25rem] h-[2.25rem] rounded-full flex justify-center items-center ">
                  <span className="text-[#0092CC]">
                    {(() => {
                      let num = 1;
                      for (let i = 0; i < index; i++) {
                        if (groupedData?.[i]?.isGroup) num++;
                      }
                      return num;
                    })()}
                  </span>
                </div>
                {record?.paComponetName}
              </div>
            ),
            props: { colSpan: 3 },
          };
        }
        return record?.activityName;
      },
    },

    {
      title: "Date Created",
      dataIndex: "dateCreated",
      render: (text, record) =>
        record.isGroup
          ? { props: { colSpan: 0 } }
          : moment(text).format("DD/MM/YYYY"),
    },
    {
      title: "Start Date",
      dataIndex: "paStartDate",
      render: (text, record) =>
        record.isGroup
          ? { props: { colSpan: 0 } }
          : moment(text).format("DD/MM/YYYY"),
    },
    {
      title: "End Date",
      dataIndex: "paEndDate",
      render: (text, record) =>
        record.isGroup ? record.paEndDate : moment(text).format("DD/MM/YYYY"),
    },
    {
      title: "Duration",
      dataIndex: "paDuration",
      render: (text, record) => (record.isGroup ? record.paDuration : text),
    },
    {
      title: "Issues",
      dataIndex: "paIssuesCount",
      render: (_, record) => (record.isGroup ? record.paIssuesCount : _),
    },
    ...(!["COMPLETED", "STALLED"]?.includes(activeObjOngoingProject?.projectStatus)
      ? [
          {
            title: "Actions",
            key: "actions",
            render: (_, record, item) => {
              if (record?.isGroup) {
                return {
                  children: (
                    <button
                      onClick={() => handleAdd(record)}
                      type="button"
                      className="bg-[#0092CC] flex items-center justify-center p-[.5rem] rounded-[.375rem]"
                    >
                      <img src={svg29} alt="svg29" />
                    </button>
                  ),
                  props: { colSpan: 1 },
                };
              }
              return (
                <Dropdown
                  overlayStyle={{
                    width: "250px",
                  }}
                  trigger={"click"}
                  menu={{ items: settingItems }}
                  placement="bottom"
                >
                  <button onClick={() => setProdd(record)}>
                    <img src={svg27} alt="svg27" />
                  </button>
                </Dropdown>
              );
            },
          },
        ]
      : []),
  ];

  const groupDataByComponentId = (data) => {
    const parents = data?.filter((item) => item?.isGroup);
    return parents?.map((parent) => ({
      parent,
      children: data?.filter(
        (item) => !item?.isGroup && item?.paComponentId === parent?.paComponentId
      ),
    }));
  };

  const groups = groupDataByComponentId(data);
  const pagedGroups = groups.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);
  const groupedData = pagedGroups.flatMap(({ parent, children }) => [parent, ...children]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      <div className="flex flex-col w-full  flex-1">
        <div className="flex lg:flex-row flex-col lg:items-center justify-between  gap-y-4">
          <div className="form-add-h">Component Activities</div>
          <div className="flex flex-wrap items-center lg:justify-end justify-start gap-[.62rem]">
            <div className="lg:w-[16.125rem] w-full  ">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search"}
              />
            </div>
          </div>
        </div>
        <Table
          rowClassName={(record) => (record.isGroup ? "" : "")}
          rowSelection={false}
          bordered={false}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: groups.length,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
          // rowKey={(record) => record?.paId}
          columns={columns}
          dataSource={groupedData}
          scroll={{
            x: 'auto',
          }}
          className="mt-[1.94rem] "
          loading={loading}
        />
      </div>
      <ActivityAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
        prodd2={prodd2}
      />
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </>
  );
}

export default ActivityTable;
